import styled from "styled-components";

export const StyledLogo = styled.h1`
    font-size: 23px;
    color: var(--dark--green--50);
    height: 90px;
    line-height: 92px;
`